import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Square } from 'lucide-react';

function EndNodeComponent({ data, selected }) {
  return (
    <div
      className={`
        relative px-4 py-3 rounded-xl border-2 min-w-[120px]
        bg-gradient-to-br from-red-500/20 to-red-600/10
        ${selected ? 'border-red-400 shadow-lg shadow-red-500/30' : 'border-red-500/50'}
        transition-all duration-200
      `}
    >
      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-red-400 !border-2 !border-red-600"
      />
      
      {/* Node Content */}
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded-lg bg-red-500/30">
          <Square className="h-4 w-4 text-red-400" />
        </div>
        <span className="text-sm font-semibold text-white">
          End Journey
        </span>
      </div>
    </div>
  );
}

export const EndNode = memo(EndNodeComponent);
